package co.maytes.standupbot.dashboard.features.auth

import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.shared.dto.auth.CurrentUserDto
import com.kttipay.mvi.api.MVIAction
import com.kttipay.mvi.api.MVIIntent
import com.kttipay.mvi.api.MVIState

sealed interface AuthPhase {
    data object Loading : AuthPhase
    data object Unauthenticated : AuthPhase
    data class Authenticated(val userId: String) : AuthPhase
}

object AuthContract {
    data class State(
        val phase: AuthPhase = AuthPhase.Loading,
        val user: CurrentUserDto? = null,
    ) : MVIState

    sealed interface Intent : MVIIntent {
        data object Bootstrap : Intent
        data object SignOut : Intent
        data object SignOutEverywhere : Intent
        data object RemoteSignedOut : Intent
        data object MarkOnboardingComplete : Intent
    }

    sealed interface Action : MVIAction {
        data object BootstrappedUnauthenticated : Action
        data object SignedOut : Action
        data class SignOutEverywhereFailed(val error: ApiError) : Action
        data object OnboardingCompleted : Action
        data class OnboardingMarkFailed(val error: ApiError) : Action
    }
}
